import { call, put } from 'redux-saga/effects'

import { FrontendSetting } from '../../../interfaces/setting'
import { handleUnAuthorizedError } from '../../../utils/saga.util'
import { requestFailure, updateFrontendSettingSucceed } from '../actions'

export function* updateFrontendSettingSaga(
  settingApi: {
    updateFrontendSetting: (...args: any[]) => any
  },
  {
    payload: frontendSetting
  }: {
    payload: FrontendSetting
  }
) {
  try {
    const { data } = yield call(
      settingApi.updateFrontendSetting,
      frontendSetting
    )
    yield put(updateFrontendSettingSucceed(data))
  } catch (e) {
    yield handleUnAuthorizedError(e)
    yield put(requestFailure(e))
  }
}
